export default __webpack_public_path__ + "static/media/task.0c5b5609.png";